import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'

interface CustomDatePickerProps {
  label: string
  inputName: string
  value: Dayjs | null
  minDate?: Dayjs | null
  handleInputChange: (inputName: string, value: any) => void
}

function CustomDatePicker({ label, inputName, value, minDate, handleInputChange }: CustomDatePickerProps) {
  const { t } = useTranslation(['global'])

  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleChange = (dateTime: Dayjs | null) => {
    handleInputChange(inputName, dateTime)
  }

  return (
    <DatePicker
      label={t(label)}
      value={value ? dayjs(value) : null}
      minDate={minDate ? dayjs(minDate) : undefined}
      onChange={newDate => handleChange(newDate)}
      slotProps={{
        textField: { fullWidth: true, error: !!errorForm['inputName'], helperText: msgForm[inputName] }
      }}
    />
  )
}

export default CustomDatePicker
